import React from "react";

/**
 * Sentiment chip - tiny visual badge based on LLM analysis.
 */
const STYLES = {
  positive: "bg-[#E6F1E0] text-[#3F6B3A] border-[#CFE3C5]",
  negative: "bg-[#F2D8CF] text-[#C05B3B] border-[#E8B5A6]",
  neutral:  "bg-[#F3EFE9] text-[#5C6B5F] border-[#EAE5D9]",
};
const LABEL = { positive: "+100 JSK", negative: "−50 JSK", neutral: "0 JSK" };

export default function SentimentChip({ sentiment, size = "sm" }) {
  if (!sentiment) return null;
  const s = STYLES[sentiment] || STYLES.neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border ${s} ${size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5"}`}
      data-testid={`sentiment-${sentiment}`}
    >
      {LABEL[sentiment] || sentiment}
    </span>
  );
}
